// Mock data for Global Boutique

export const shopInfo = {
  name: "Global Boutique",
  tagline: "Elegance Woven with Tradition",
  experience: "20+ Years of Excellence",
  location: {
    address: "Ground floor Maharaja Heights complex",
    area: "Hyderpora Chowk",
    city: "Srinagar",
    state: "Jammu and Kashmir"
  },
  contact: {
    whatsapp: "917006350074",
    instagram: "global.boutique7"
  },
  logo: "https://customer-assets.emergentagent.com/job_heritage-boutique-1/artifacts/v29bsbox_gb.png"
};

export const services = [
  {
    id: 1,
    title: "Premium Fabrics",
    description: "Curated collection of high-quality fabrics including silk, cotton, chiffon, and designer materials from across the world."
  },
  {
    id: 2,
    title: "Traditional Kashmiri Wear",
    description: "Authentic Kashmiri Pherans, shawls, and traditional attire crafted with intricate embroidery and local artistry."
  },
  {
    id: 3,
    title: "Designer Collections",
    description: "Exclusive designer fabrics with unique patterns, perfect for creating stunning outfits for special occasions."
  },
  {
    id: 4,
    title: "Custom Tailoring",
    description: "Expert tailoring services to bring your vision to life with precision and attention to detail."
  }
];

export const galleryImages = [
  {
    id: 1,
    url: "https://customer-assets.emergentagent.com/job_a7763a7b-9f7d-4150-a151-fed4805480f4/artifacts/ky3g7ua9_asas.jpeg",
    alt: "Shop Interior - Colorful Fabric Collection",
    category: "shop"
  },
  {
    id: 2,
    url: "https://customer-assets.emergentagent.com/job_a7763a7b-9f7d-4150-a151-fed4805480f4/artifacts/xok7io0q_cx.jpeg",
    alt: "Owner showcasing premium fabric",
    category: "shop"
  },
  {
    id: 3,
    url: "https://customer-assets.emergentagent.com/job_a7763a7b-9f7d-4150-a151-fed4805480f4/artifacts/f1anlczk_efef.jpeg",
    alt: "Vibrant fabric patterns with traditional designs",
    category: "fabric"
  },
  {
    id: 4,
    url: "https://customer-assets.emergentagent.com/job_a7763a7b-9f7d-4150-a151-fed4805480f4/artifacts/a9mwnmxg_fef.jpeg",
    alt: "Exquisite embroidered fabric in pink and black",
    category: "fabric"
  }
];

export const reviews = [
  {
    id: 1,
    name: "Aisha Malik",
    location: "Srinagar",
    rating: 5,
    text: "Best fabric collection in Srinagar! The quality is exceptional and the owner's expertise really shows. I've been buying from Global Boutique for years.",
    date: "2024-11"
  },
  {
    id: 2,
    name: "Farooq Ahmad",
    location: "Hyderpora, Srinagar",
    rating: 5,
    text: "Excellent service and amazing variety of fabrics. The traditional Kashmiri materials are authentic and beautifully crafted.",
    date: "2024-10"
  },
  {
    id: 3,
    name: "Zainab Khan",
    location: "Rajbagh, Srinagar",
    rating: 5,
    text: "I found the perfect fabric for my wedding outfit here. The staff is knowledgeable and helped me choose exactly what I needed.",
    date: "2024-09"
  },
  {
    id: 4,
    name: "Mohammad Yousuf",
    location: "Srinagar",
    rating: 5,
    text: "20+ years of trust and quality! My family has been shopping here for generations. Always fresh stock and reasonable prices.",
    date: "2024-08"
  },
  {
    id: 5,
    name: "Sameera Hassan",
    location: "Buchpora, Srinagar",
    rating: 5,
    text: "The designer collection is absolutely stunning. Found unique fabrics here that I couldn't find anywhere else in Kashmir.",
    date: "2024-07"
  },
  {
    id: 6,
    name: "Imran Shah",
    location: "Bemina, Srinagar",
    rating: 5,
    text: "Great location, easy to find at Hyderpora Chowk. Quality fabrics at fair prices with honest advice.",
    date: "2024-06"
  }
];

export const products = [
  {
    id: 1,
    name: "Pure Silk Collection",
    description: "Luxurious silk fabrics in various colors and textures"
  },
  {
    id: 2,
    name: "Cotton Varieties",
    description: "Breathable cotton fabrics for everyday comfort"
  },
  {
    id: 3,
    name: "Embroidered Designs",
    description: "Handcrafted embroidered fabrics with intricate patterns"
  },
  {
    id: 4,
    name: "Kashmiri Shawls",
    description: "Authentic Pashmina and woolen shawls"
  },
  {
    id: 5,
    name: "Bridal Fabrics",
    description: "Special occasion and bridal collection"
  },
  {
    id: 6,
    name: "Designer Prints",
    description: "Contemporary patterns and modern designs"
  }
];

export const unstitchedCollection = {
  name: "Ramsha Ghazal Luxury Lawn",
  volume: "Vol - 05",
  description: "Exquisite unstitched lawn collection featuring intricate embroidery, vibrant colors, and premium quality fabrics. Perfect for the discerning customer seeking elegance and sophistication.",
  designs: [
    {
      id: "G-501",
      name: "G-501",
      color: "Warm Brown/Caramel",
      image: "https://images.pexels.com/photos/22064230/pexels-photo-22064230.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
      embroidery: "Extensive embroidery in cream, beige, and muted red/pink tones with intricate floral patterns",
      pieces: "3-Piece Unstitched",
      fabric: "Premium Lawn"
    },
    {
      id: "G-502",
      name: "G-502",
      color: "Black",
      image: "https://images.pexels.com/photos/19011747/pexels-photo-19011747.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
      embroidery: "Vibrant multi-colored embroidery with intricate floral and paisley motifs",
      pieces: "3-Piece Unstitched",
      fabric: "Premium Lawn"
    },
    {
      id: "G-503",
      name: "G-503",
      color: "Mint Green/Aqua Blue",
      image: "https://images.pexels.com/photos/20407193/pexels-photo-20407193.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
      embroidery: "Delicate embroidery in pink, maroon, and green with floral patterns",
      pieces: "3-Piece Unstitched",
      fabric: "Premium Lawn"
    },
    {
      id: "G-504",
      name: "G-504",
      color: "Dusty Rose/Pale Pink",
      image: "https://images.pexels.com/photos/19248190/pexels-photo-19248190.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
      embroidery: "Intricate embroidery in pink, white, and silver with delicate floral motifs",
      pieces: "3-Piece Unstitched",
      fabric: "Premium Lawn"
    },
    {
      id: "G-505",
      name: "G-505",
      color: "Deep Navy Blue/Indigo",
      image: "https://images.pexels.com/photos/19011575/pexels-photo-19011575.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
      embroidery: "Dense multi-colored embroidery with detailed floral motifs",
      pieces: "3-Piece Unstitched",
      fabric: "Premium Lawn"
    },
    {
      id: "G-506",
      name: "G-506",
      color: "Deep Red/Maroon",
      image: "https://images.pexels.com/photos/34933667/pexels-photo-34933667.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
      embroidery: "Intricate embroidery in white, silver, and muted tones with paisley patterns",
      pieces: "3-Piece Unstitched",
      fabric: "Premium Lawn"
    },
    {
      id: "G-507",
      name: "G-507",
      color: "Forest Green/Emerald",
      image: "https://images.pexels.com/photos/19487468/pexels-photo-19487468.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
      embroidery: "Detailed embroidery in pink, maroon, and green with intricate patterns",
      pieces: "3-Piece Unstitched",
      fabric: "Premium Lawn"
    },
    {
      id: "G-508",
      name: "G-508",
      color: "Teal/Deep Turquoise",
      image: "https://images.pexels.com/photos/25288439/pexels-photo-25288439.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
      embroidery: "Beautiful embroidery in pinks and purples with floral patterns",
      pieces: "3-Piece Unstitched",
      fabric: "Premium Lawn"
    }
  ]
};

export const pricingPlans = [
  {
    id: 1,
    name: "Basic Stitching",
    price: "₹800",
    description: "Starting from",
    features: [
      "Professional stitching",
      "Standard fitting",
      "Quality thread work",
      "Basic finishing"
    ],
    popular: false
  },
  {
    id: 2,
    name: "Half Lining",
    price: "₹1,300",
    description: "Complete package",
    features: [
      "Premium stitching",
      "Half lining included",
      "Perfect fitting",
      "Enhanced durability"
    ],
    popular: true
  },
  {
    id: 3,
    name: "Full Lining",
    price: "₹1,700",
    description: "Premium service",
    features: [
      "Expert stitching",
      "Full lining included",
      "Perfect finishing",
      "Maximum comfort"
    ],
    popular: false
  },
  {
    id: 4,
    name: "Custom Designs",
    price: "Variable",
    description: "Based on design complexity",
    features: [
      "Personalized designs",
      "Embroidery work",
      "Special embellishments",
      "Designer patterns"
    ],
    popular: false
  }
];
